/* nombre dispositivo grupo subgrupo latitud longitud */
import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from "context/autentication/authContext";
import ClienteContext from "context/cliente/clienteContext";
import { Button, Grid } from "@material-ui/core";
import { Role } from "types/roles";

const useStyles = makeStyles((theme) => ({
  formularioFechas: {
    padding: theme.spacing(2),
  },
  formularioBotones: {
    margin: theme.spacing(1),
  },
  formularioLinkRapido: {
    fontSize: "0.8rem",
  },
}));

export default function Soporte(props) {
  const classes = useStyles();
  //const classes = useStyles();
  const authContext = useContext(AuthContext);
  const { usuario, cliente } = authContext;
  const clienteContext = useContext(ClienteContext);
  const {
    obtenerClientes,
    obtenerClientesSoporte,
    rolCliente,
    eliminarRolCliente,
  } = clienteContext;
  const [creador, setCreador] = useState();
  const [state, setState] = useState({
    idCliente: creador ? creador[0].clienteCreador._id : "",
    rol: Role.Soporte,
    cliente: cliente,
  });
  const cambiar = () => {
    if (props.estado) {
      eliminarRolCliente(state);
      props.funcion();
      props.handleClose();
    } else {
      rolCliente(state);
      props.funcion();
      props.handleClose();
    }
  };
  const clienteCreador = (value) => {
    if (value) {
      setCreador(value.filter((v) => v._id === cliente));
    }
  };

  useEffect(() => {
    if (cliente) {
      obtenerClientes(usuario.clienteRol[0].cliente.clienteCreador).then(
        (value) => clienteCreador(value)
      );
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (creador) {
      setState({
        idCliente: creador[0].clienteCreador._id,
        rol: Role.Soporte,
        cliente: cliente,
      });
    }
    // eslint-disable-next-line
  }, [creador]);
  return (
    <div style={{ width: "700px" }}>
      {creador ? (
        props.estado ? (
          <Grid container direction="row">
            <Grid items xs={12} md={12} lg={12}>
              <p style={{ fontSize: "25px", margin: "5px" }}>
                ¿Desea quitar los permisos de asistencia remota a{" "}
                <strong>{creador[0].clienteCreador.razonSocial}</strong>?
              </p>
            </Grid>
            <Grid items xs={12} md={12} lg={12} style={{ margin: "25px" }}>
              <p style={{ fontSize: "18px" }}>
                Al hacerlo <strong>no</strong> le permite más a{" "}
                <strong>{creador[0].clienteCreador.razonSocial}</strong> que
                acceda a su panel y lo ayude con la organización de sus
                dispositivos. <br></br>
                Puede anular esta acción en cualquier momento.
              </p>
            </Grid>
          </Grid>
        ) : (
          <Grid container direction="row">
            <Grid items xs={12} md={12} lg={12}>
              <p style={{ fontSize: "25px", margin: "5px" }}>
                ¿Desea dar permisos de asistencia remota a{" "}
                <strong>{creador[0].clienteCreador.razonSocial}</strong>?
              </p>
            </Grid>
            <Grid items xs={12} md={12} lg={12} style={{ margin: "25px" }}>
              <p style={{ fontSize: "18px" }}>
                Al hacerlo le esta permitiendo a{" "}
                <strong>{creador[0].clienteCreador.razonSocial}</strong> que
                acceda a su panel y lo ayude con la organización de sus
                dispositivos. <br></br>
                Puede anular esta acción en cualquier momento.
              </p>
            </Grid>
          </Grid>
        )
      ) : null}
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
          onClick={() => cambiar()}
        >
          Aceptar
        </Button>
        <Button
          color="primary"
          variant="outlined"
          style={{ color: "#0B3845" }}
          onClick={() => props.handleClose()}
        >
          Cancelar
        </Button>
      </Grid>
    </div>
  );
}
